const initialState =
{
	order                : 'asc',
	isScrollEnd          : true,
	messages             : [],
	broadcastMessage     : [],
	count                : 0,
	countUnread          : 0,
	broadcastCount       : 0,
	countBroadcastUnread : 0,
	isBroadcastScrollEnd : true
};

const chat = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_MESSAGE':
		{
			const { message } = action.payload;

			return {
				...state,
				messages    : [ ...state.messages, message ],
				count       : state.count + 1,
				countUnread : message.sender === 'response' ? ++state.countUnread : state.countUnread
			};

		}
		case 'ADD_BROADCAST_MESSAGE':
		{
			const { broadcastMessage } = action.payload;

			return {
				...state,
				broadcastMessage     : [ ...state.broadcastMessage, ...broadcastMessage ],
				broadcastCount       : state.broadcastCount + 1,
				countBroadcastUnread : broadcastMessage[0]?.myId !== broadcastMessage[0]?.userId ? ++state.countBroadcastUnread : state.countBroadcastUnread
			};

		}
		case 'REMOVE_BROADCAST_COUNT':
		{
			// const { broadcastMessage } = action.payload;

			return {
				...state,
				countBroadcastUnread : 0
			};
		}

		case 'ADD_CHAT_HISTORY':
		{
			const { chatHistory } = action.payload;

			chatHistory.forEach(
				(item, index) => { chatHistory[index].isRead = true; }
			);

			return {
				...state,
				messages : chatHistory,
				count    : chatHistory.length
			};
		}

		case 'CLEAR_CHAT':
		{
			return {
				...state,
				messages    : [],
				count       : 0,
				countUnread : 0
			};
		}

		case 'SORT_CHAT':
		{
			const { order } = action.payload;

			return { ...state, order: order };
		}

		case 'SET_IS_SCROLL_END':
		{
			const { flag } = action.payload;

			return { ...state, isScrollEnd: flag };
		}

		case 'SET_IS_MESSAGE_READ':
		{
			const { id, isRead } = action.payload;

			console.log('SET_IS_MESSAGE_READ=', action);

			state.messages.forEach((key, index) =>
			{
				// Only count a message down once, and never below zero: the scroll
				// handler can dispatch the same id repeatedly before React commits.
				if (state.messages[index].time === Number(id) && !state.messages[index].isRead)
				{
					state.messages[index].isRead = isRead;

					if (state.countUnread > 0)
					{
						state.countUnread--;
					}
				}
			});

			return { ...state };
		}
		case 'SET_IS_BROADCAST_SCROLL_END':
		{
			const { flag } = action.payload;

			return { ...state, isBroadcastScrollEnd: flag };
		}
		case 'SET_IS_BROADCAST_MESSAGE_READ':
		{
			const { id, isRead } = action.payload;

			state.broadcastMessage.forEach((key, index) =>
			{
				if (state.broadcastMessage[index].sendTime === Number(id))
				{
					state.broadcastMessage[index].isRead = isRead;

					if (state.countBroadcastUnread > 0)
					{

						state.countBroadcastUnread--;
					}
				}
			});

			return { ...state };
		}

		default:
			return state;
	}
};

export default chat;
